"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    title: {
        id: 'task.taskDownload.title',
        defaultMessage: 'Preparing ZIP task file',
        description: 'Title for task download in snackbar',
    },
    description: {
        id: 'task.taskDownload.description',
        defaultMessage: 'Task file will be prepared and you will be informed when the download is ready.',
        description: 'Task download description',
    },
    cancelTitle: {
        id: 'task.taskDownload.cancel.title',
        defaultMessage: 'Not completed',
        description: 'Task cancel download title',
    },
    cancelDescription: {
        id: 'task.taskDownload.cancel.description',
        defaultMessage: 'Task creation is not yet completed. Do you wish to continue to download?',
        description: 'Task cancel download description',
    },
    noShowOption: {
        id: 'task.taskDownload.noShow.option',
        defaultMessage: "Don't show again",
        description: 'Task cancel download no show option',
    },
    errorTitle: {
        id: 'task.taskDownload.error.title',
        defaultMessage: 'There was a problem with that action',
        description: 'Title for task download errors',
    },
    errorForDownload: {
        id: 'task.taskDownload.error.download',
        defaultMessage: 'We are unable to request the task file for download. Please check your connection.',
        description: 'Text body for task download error',
    },
    errorForSaveAsDraft: {
        id: 'task.taskDownload.error.saveAsDraft',
        defaultMessage: 'We are unable to save your task file as draft. Please check your connection.',
        description: 'Text body for task save as draft error',
    },
});
exports.default = messages;
